define('views/shared/form/input/birthdate_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/birthdate_component.html',
    'views/shared/form/input/telephone_component',
    'models/validator/month',
    'models/validator/year'
], function(Backbone, BaseView, Template, TelephoneComponent, MonthValidator, YearValidator){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'blur input'   : 'inputBlur',
            'focus input'  : 'inputFocus',
            'keydown input': 'keydownValidateBirthdate',
            'keyup input'  : 'keyupValidateBirthdate'
        },

        base_date: 1970,

        birthdate: {
            valid   : null,
            value   : null,
            empty   : true,
            active  : false,
            touched : false,
            complete: false
        },

        initialize: function(options){
            options = options || {};

            this.field = options.field;

            this.is_valid = false;
            this.error_feedback = this.field.error.empty;

            this.soft_error = false;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;
            
            // if autocomplete is false and we're in chrome
            if (!this.field.autocomplete && window.chrome) {  
                this.field.autocomplete = 'autocomplete-off-' + (new Date()).getTime();
            }             


            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();
            
        },

        getValue: function(){

            if(this.field.encrypt){
                return encrypt(this.birthdate.read_value);
            } else {
                return this.birthdate.read_value;
            }
            
        },

        checkField: function(){

            if(this.birthdate.valid){
                this.is_valid = true;
            } else {
                this.is_valid = false;
            }

        },

        showError: function(){

            // this.checkField();

            if(!this.is_valid){
                this.$el.find('.js-form-input-feedback').html(this.error_feedback);
            } else {
                this.removeError();
            }

        },

        removeError: function(){
            this.$el.find('.js-form-input-feedback').html('');
            // this.$el.removeClass('outline-error');
            // this.soft_error = false;
        },

        showDataMatchingError: function(){
            this.$el.addClass('outline-error');
            this.soft_error = true;
        },


        /*
            Focus Event
        */

        
        inputFocus: function(){
            this.birthdate.touched = true;
            this.birthdate.active = true;
        },

        /*
            Blur Event
        */

        inputBlur: function(){
            this.birthdate.active = false;
            this.validateBirthdate();
        },

        validateBirthdate: function(){
            var input_value = (this.birthdate.value) ? this.birthdate.value : '',
                month = input_value.slice(0,2),
                day = input_value.slice(2,4),
                year = input_value.slice(4),
                month_validator = new MonthValidator,
                year_validator = new YearValidator;

            if(input_value.length == 8){

                month_validator.validate(month);
                year_validator.validate(year);

                var month = month_validator.getIntValue(),
                    year = year_validator.getIntValue(),
                    now = new Date(),
                    card_date = new Date(),
                    later_date = true;

                var month_is_valid;
                if(!month_validator.isValid()){
                    // styleInputError(month);
                    month_is_valid = false;
                } else if(year == now.getFullYear() && month < (now.getMonth() + 1)){
                    // Date chosen is in the current year, but in the past, thus invalid
                    // styleInputError(month);
                    month_is_valid = false;
                } else { // Valid
                    // styleInputValid(month);
                    month_is_valid = true;
                }

                var year_is_valid;
                if(!year_validator.isValid()){
                    // styleInputError(year);
                    year_is_valid = false;
                } else { // Valid
                    // styleInputValid(year);
                    year_is_valid = true;
                }

                var birthdate = new Date();

                birthdate.setFullYear(year, month - 1, day);

                var date_time_difference = Date.now() - birthdate.getTime(),
                    utc_date = new Date(date_time_difference),
                    age = Math.abs(utc_date.getUTCFullYear() - this.base_date);

                if(age < 18){

                    this.error_feedback = this.field.error.invalid;
                    this.birthdate.valid = false;
                    this.is_valid = false;

                    this.birthdate.complete = false;

                    this.showError();

                } else {

                    this.birthdate.valid = true;
                    this.is_valid = true;

                    this.birthdate.complete = true;

                    this.removeError();
                    
                }

            } else if(input_value.length == 6){

                this.error_feedback = this.field.error.format;

                this.showError();

            } else {
                this.birthdate.valid = false;
                this.is_valid = false;
                this.error_feedback = this.field.error.empty;
            }

        },

        keyupValidateBirthdate: function(e){
            var val = $(e.target).val(),
                true_value = val.split(' ').join('').replace('/', '').replace('/', ''),
                new_value = true_value.replace(/(.{2})/g, '$1/'),
                middle_value = true_value.replace(/(.{2})(.{2})/g, '$1/$2/'),
                last_value = true_value.replace(/(.{2})(.{2})(.{4})/g, '$1/$2/$3'),
                len = true_value.length;

            this.birthdate.value = true_value;
            this.birthdate.read_value = val;

            if(len == 1 && true_value && true_value != '0' && true_value != '1'){
                
                var new_true_value = '0' + true_value;
                var combined_value = new_true_value.replace(/(.{2})/g, '$1/');

                $(e.target).val(combined_value);

                this.birthdate.empty = false;

            } else if(len == 2 && e.keyCode != 46 && e.keyCode != 8){

                var new_value = true_value.replace(/(.{2})/g, '$1/');
                $(e.target).val(new_value);

                this.birthdate.empty = false;

            } else if(len == 4 && e.keyCode != 46 && e.keyCode != 8){
                
                var new_value = true_value.replace(/(.{2})(.{2})/g, '$1/$2/');
                $(e.target).val(new_value);

                this.birthdate.empty = false;

            }

            // Validate and format card number
            if(len == 8 || len == 0){

                if(len == 8){
                    
                    this.birthdate.complete = true;
                    this.birthdate.empty = false;
                    
                } else {

                    this.birthdate.empty = true;

                }

                this.validateBirthdate();
                
            }

            return false;

        },

        keydownValidateBirthdate: function(e){
            
            switch(true){
                case e.keyCode >= 48 && e.keyCode <= 57:   // Numbers
                case e.keyCode >= 96 && e.keyCode <= 105:  // Numberpad
                case e.keyCode == 37:   // Left Arrow
                case e.keyCode == 39:   // Right Arrow
                case e.keyCode == 8:    // Backspace
                case e.keyCode == 46:   // Delete
                case e.keyCode == 32:   // Space
                case e.keyCode == 9:    // Tab
                // case e.keyCode == 191:  // Forward Slash
                // case e.keyCode == 111:  // Forward Slash
                case e.keyCode == 91:   // Command
                case e.keyCode == 16:   // Shift
                case e.keyCode == 17:   // Control
                case e.keyCode == 18:   // Control
                case e.keyCode == 86:   // V Character
                case e.keyCode == 82:   // R Character
                    this.birthdate.touched = true;
                    this.formatBirthdate(e);
                    // console.log('keydownValidateBirthdate',e.keyCode, this);
                    break;
                default:
                    return false;
                    break;
            }
            
        },

        formatBirthdate: function(e){
            var val = $(e.target).val(),
                true_value = val.split(' ').join('').replace('/', '').replace('/', ''),
                new_value = true_value.replace(/(.{2})/g, '$1/'),
                len = true_value.length;

            this.birthdate.complete = false;

            if(len == 1){

                $(e.target).val(new_value);

            } else if(len == 0){
                this.birthdate.empty = true;
                this.validateBirthdate();
            } else if(len >= 8 && e.keyCode != 46 && e.keyCode != 8 && e.keyCode != 9){

                if(e && e.preventDefault){ e.preventDefault(); }
                if(e && e.stopPropagation){ e.stopPropagation(); }

            }

        },

        close: function(){}

    });
});

